import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { ReportHistoricalFilter } from "@report/domain/models/report.model";
import type { ReportRepository } from "@report/domain/repositories/report.repository";
import { reportTypes } from "@report/report-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class ReportHistoricalRequestMailUseCase {
    constructor(
        @inject(reportTypes.repositories.ReportRepository)
        private readonly reportRepository: ReportRepository,
    ) {}

    async execute(historicalFilters: ReportHistoricalFilter): Promise<boolean> {
        const reportHistoricalRequestMailResult =
            await this.reportRepository.requestHistoricalReportMail(
                historicalFilters,
            );

        if (reportHistoricalRequestMailResult.isErr()) {
            ToastManagerRepository.error(
                reportHistoricalRequestMailResult.error.message,
            );
            return false;
        }

        ToastManagerRepository.success();
        return reportHistoricalRequestMailResult.isOk();
    }
}
